module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Orange-2083fb8ea4e2e3b680543ebad8ae510d.svg";